const RECHARGE_GROUP_COUNTS = [
  'RECHARGE_NOT',
  'RECHARGE_FIRST',
  'RECHARGE_SECOND',
  'RECHARGE_THIRD',
  'RECHARGE_FOUR',
];

export const getCompletedRechargeCount = (presetGroupTypeList?: string[]) => {
  const count = RECHARGE_GROUP_COUNTS.findIndex(groupType =>
    presetGroupTypeList?.includes(groupType),
  );
  return count >= 0 ? count : 0;
};
